module.exports = __webpack_public_path__ + "images/close_icon28115a5d671a0cdfc40123d1c90b6a55.svg";